import type { Action } from 'react-sweet-state';
import type { StoreBaseContainerProps } from '../../../../common/types';
import { createDataResponse, createErrorResponse } from '../../../../common/utils/store';
import { multiplePromiseSettler } from '../../utils';
import * as endpoints from '../endpoints';
import type { IncidentsState } from '../types';

const getIncidentsCopyStatus =
	(): Action<IncidentsState, StoreBaseContainerProps> =>
	({ setState, getState }, { cloudId }) => {
		const state = getState();
		setState({
			incidentsCopyStatus: {
				...state.incidentsCopyStatus,
				loading: true,
			},
		});
		return endpoints
			.getIncidentsCopyStatus(cloudId)
			.then((res) => setState({ incidentsCopyStatus: createDataResponse(res) }))
			.catch((err) => {
				setState({ incidentsCopyStatus: createErrorResponse(err) });
				throw err;
			});
	};

// Get status after copy is started and update the state
const copyIncidents =
	(): Action<IncidentsState, StoreBaseContainerProps> =>
	({ dispatch }, { cloudId }) =>
		endpoints.copyIncidents(cloudId).then(() => dispatch(getIncidentsCopyStatus()));

const initialize =
	(): Action<IncidentsState, StoreBaseContainerProps, Promise<PromiseSettledResult<void>[]>> =>
	({ dispatch }) =>
		Promise.allSettled([dispatch(getIncidentsCopyStatus())]).then(multiplePromiseSettler);

export const actions = {
	getIncidentsCopyStatus,
	copyIncidents,
	initialize,
};
